import cookies from 'js-cookie';
import axios from 'axios';

const requestAPI = (params) => {
	const authToken = cookies.get('auth_token');
	let dataForQueryStringLength = 0;
	let queryString = '';
	let countIterations = 0;

	if (params.additionalQueryStringParams) {
		dataForQueryStringLength = Object.keys(params.additionalQueryStringParams).length;
	}

	for (let key in params.routeParams) {
		queryString += params.routeParams[key] + '/';
	}

	if (params.additionalQueryStringParams) {
		queryString += '?';

		for (let key in params.additionalQueryStringParams) {
			countIterations += 1;

			if (countIterations !== dataForQueryStringLength) {
				queryString = queryString + key + '=' + params.additionalQueryStringParams[key] + '&';
			} else {
				if (Array.isArray(params.additionalQueryStringParams[key])) {
					for (let i = 0; i < params.additionalQueryStringParams[key].length; i++) {
						if (i + 1 === params.additionalQueryStringParams[key].length) {
							queryString = queryString + key + '=' + params.additionalQueryStringParams[key][i];
						} else {
							queryString = queryString + key + '=' + params.additionalQueryStringParams[key][i] + '&';
						}
					}
				} else {
					queryString = queryString + key + '=' + params.additionalQueryStringParams[key];
				}
			}
		}
	}

	let apiUrl = 'http://api.pbnscavengers.com/api/';
	if (params.withoutApiInEnd) apiUrl = 'http://api.pbnscavengers.com';
	if (params.anotherApi) apiUrl = 'http://5.43.226.143:8000/';
	if (params.useCustomURL) apiUrl = params.useCustomURL

	let requestBody = {
		url: apiUrl + queryString,
		headers: {
			Authorization: `Token ${authToken}`
		}
	};

	if (params.data) requestBody.data = params.data;
	if (params.type) requestBody.responseType = params.type;
	if (params.method) requestBody.method = params.method; //default in axios 'GET'
	if (params.blobDownload) requestBody.responseType = 'blob'; //need for normal download files
	if (params.routeParams.route === 'login') delete requestBody.headers;

	return axios(requestBody);
};

export default requestAPI;
